<template>
  <span
    class="ui-categorybadge"
    :style="JSON.stringify(computedStyle)"
    :data-custom-style="JSON.stringify(computedStyle)"
    @click="$emit('edit')"
    >
    <span v-if="text && !iconLeft" v-text="text"/>
    <slot v-if="!iconLeft"/>
    <i
      v-if="svg"
      :class="svg"
      class="fa text-slate-500/40 cursor-pointer align-middle"
      @click="$emit('remove')"/>
    <slot v-if="iconLeft"/>
    <span v-if="text && iconLeft" @click="$emit('edit')" v-text="text"/>
    <i v-if="editable" class="fa fa-times text-gray-700 cursor-pointer pl-2 align-middle" @click="$emit('remove')"/>
    <i v-if="addable" class="fa fa-plus text-gray-700 cursor-pointer pl-2 align-middle" @click="$emit('add')"/>
  </span>
</template>

<script setup lang="ts">
defineEmits(['remove','add','edit'])
defineProps<{
  svg?: string|object
  text?: string
  editable?: boolean
  addable?: boolean
  iconLeft?: boolean
  randomColor?: boolean
}>();

const computedStyle = computed(() => {
  // TOOD

  return {}
})
</script>
